module.exports = __webpack_public_path__ + "media/images/logo_big-7c531a77bf8c869b24c19ca1da93d68d.svg";